import { MemberListPage } from './MemberListPage';
import { withMemberListPage } from './withMemberListPage';

const ConnectedMemberListPage = withMemberListPage(MemberListPage);

export { ConnectedMemberListPage as MemberListPage };
